module.exports = {"TXTWCL_Your_voucher_amount":{"id":"TXTWCL_Your_voucher_amount","defaultMessage":"Сума на ваучера","track":"Your voucher amount"}}